import React from 'react';

const TabSystem = ({ activeTab, setActiveTab }) => {
  const tabs = [
    { id: 'mandate', label: 'Mandate Search' },
    { id: 'nlp', label: 'Natural Language Search' }
  ];

  return (
    <div className="tab-system">
      <div className="tab-buttons">
        {tabs.map(tab => (
          <button
            key={tab.id}
            className={`tab-button ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default TabSystem;
